<template>
  <main>
    <ticker-admin-nav />
    <h4>Universal Security Master </h4>
    <h5>Companies</h5>
    <article class="row">
      <section class="input-field col s5">
        <input id="usm-overview-search"
               class="validate"
               type="text"
               name="search"
               placeholder="e.g. micros"
               v-model="query"
               @keyup.enter="searchCompanies()"
        >
        <label class="active" for="usm-overview-search">
          <i class="fas fa-search small unclickable"
             title="Some info tooltip, not sure what Brandon wanted"
          />
          Search Company
          <span class="progress" v-show="searching"><span class="indeterminate" /></span>
        </label>
        <span class="helper-text left teal-text text-lighten-3">
          <strong>Type and hit "Enter"</strong>
        </span>
      </section>
      <section class="col s3">
        <label>Exchange</label>
        <select class="browser-default" v-model="exchange" @change="searchCompanies()">
          <option value="">--None--</option>
          <option v-for="quotesExchange in quotesExchanges" :key="quotesExchange.id" :value="quotesExchange.modifiedSymbol">
            {{ quotesExchange.modifiedSymbol }}
          </option>
        </select>
      </section>
      <section class="col s3">
        <label>Country</label>
        <select class="browser-default" v-model="country" @change="searchCompanies()">
          <option value="">--None--</option>
          <option v-for="country in countries" :key="country.id" :value="country.code">
            {{ country.name }}
          </option>
        </select>
      </section>
      <section id="reset-btn" class="col s1">
        <a class="strong clickable" @click.prevent="resetFields()">Reset</a>
      </section>
    </article>
    <article class="row">
      <section class="col s12">
        <label class="pink-text left" v-if="companies.length > 99">
          Showing Top 100 Results
        </label>
        <table>
          <thead>
            <tr>
              <th />
              <th>Name</th>
              <th class="center-align">Active</th>
              <th>Country</th>
              <th>Sector</th>
              <th>Instruments</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="company in companies" :key="company.company_id" class="instrument-link-wrapper">
              <td>
                <object :data="`https://g.foolcdn.com/art/companylogos/mark/${company.symbol}.png`"
                        type="image/png"
                        height="30"
                        v-if="company.symbol"
                />
              </td>
              <td class="strong" v-if="company.asset_class !== 'Crypto'">
                {{ company.name}}
                <router-link :to="`/tickeradmin/editcompany?capiq_identifier=${company.capiq_identifier}` "
                             v-show="$auth.hasRoles('admin', 'recs-admin', 'contractor-usm-admin')"
                >
                  <i class="far fa-edit clickable amber-text big" />
                </router-link>
              </td>
              <td class="strong" v-else>
                {{ company.name}}
                <router-link :to="`/tickeradmin/viewcrypto?instrument_id=${company.instrument_parent_id}` "
                             v-show="$auth.hasRoles('admin', 'recs-admin', 'contractor-usm-admin')"
                >
                  <i class="far fa-edit clickable amber-text big" />
                </router-link>
              </td>
              <td class="center-align">
                <i class="fas fa-check-circle green-text" v-if="!company.inactive_date" />
                <span class="red-text">{{ company.inactive_date }}</span>
              <td>
              <img :src="`https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.1.0/flags/4x3/${company.country.code.toLowerCase()}.svg`" v-if="company.country.code"
                      height="10">
              {{company.country.name}}
              </td>
              <td>{{company.sector.name }}</td>
              <td>
                  <p v-for="instrument in company.instruments"
                     :key="instrument.instrument_parent_id"
                     class="instrument-link-wrapper"
                  >
                    <router-link v-if="instrument.asset_class === 'Crypto'" :to="`/tickeradmin/viewcrypto?instrument_id=${instrument.instrument_parent_id}`"
                                 class="instrument-link"
                    >
                      {{instrument.symbol}}
                    </router-link>
                    <router-link v-else-if="instrument.asset_class === 'Mutual Fund'" :to="`/tickeradmin/viewmutualfund?instrument_id=${instrument.instrument_parent_id}`"
                                 class="instrument-link"
                    >
                      {{instrument.exchange}}:{{instrument.symbol}}
                    </router-link>
                    <router-link v-else :to="`/tickeradmin/viewequity?instrument_id=${instrument.instrument_parent_id}`"
                                 class="instrument-link"
                    >
                      {{instrument.exchange}}:{{instrument.symbol}}
                    </router-link>
                  </p>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
    </article>
    <aside class="usm-add-security-button-wrapper" v-show="$auth.hasRoles('admin', 'recs-admin', 'contractor-usm-admin')">
      <router-link to="/tickeradmin/addinstrument" style="display: inline-block; margin-right: 20px;">
        <button class="btn-floating btn-large waves-effect waves-light teal accent-4">
          <i class="fas fa-plus" />
        </button>
        <label>Add Security</label>
      </router-link>
    </aside>
  </main>
</template>

<script>
import axios from 'axios';
import TickerAdminNav from '@/components/TickerAdminNav.vue';

export default {
  name: 'TickerAdminListCompanies',
  components: { TickerAdminNav },
  props: {},
  data() {
    return {
      query: 'micros',
      companies: [],
      candidate: { company: {}, currency: {} },
      searching: false,
      exchanges: [],
      countries: [],
      exchange: '',
      country: '',
    };
  },
  computed: {
    quotesExchanges() {
      const results = [];
      for (const exchange of this.exchanges) {
        const quotesExchange = {
          id: exchange.id,
          modifiedSymbol: exchange.quotes_symbol || exchange.symbol,
        };
        if (!results.map(quotesExchange => quotesExchange.modifiedSymbol).includes(quotesExchange.modifiedSymbol)) {
          results.push(quotesExchange);
        }
      }
      return results;
    },
  },
  watch: {},
  methods: {
    async searchCompanies() {
      if (this.query) {
        this.searching = true;
        // Update URL with search query for back button support
        if (this.$route.query.search !== this.query) {
          this.$router.replace({ query: { search: this.query } });
        }
        const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/companies/search/?q=${this.query}`);
        this.companies = data;
        setTimeout(() => {
          this.initTooltip();
        }, 200);
        this.searching = false;
      }
    },
    initTooltip() {
      this.materialize.Tooltip.init(document.querySelectorAll('.tooltipped'), {
        position: 'top',
      });
      document.getElementsByClassName('material-tooltip').forEach(elem => {
        elem.style.borderRadius = '10px';
        elem.style.backgroundColor = '#424242';
      });
    },
    async fetchExchanges() {
      const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/exchanges/`);
      this.exchanges = data;
    },
    async fetchCountries() {
      const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/countries/`);
      this.countries = data;
    },
    resetFields() {
      this.query = 'Micros';
      this.searchCompanies();
    },
  },
  async mounted() {
    // Restore search query from URL if present
    if (this.$route.query.search) {
      this.query = this.$route.query.search;
    }
    await Promise.all([
      this.searchCompanies(),
      this.fetchExchanges(),
      this.fetchCountries(),
    ]);
  },
};
</script>

<style lang="scss" scoped>
@import '@/main.scss';

.usm-add-company-aside {
  position: absolute;
  top: 100px;
  right: 30px;
  & label {
    display: block;
    margin-top: 8px;
  }
}

.instrument-link-wrapper {
  margin: 0px;
  & > .instrument-link {
    transition: color 0.25s;
    &:hover {
      color: #ffab00;
    }
  }
}

.avatar {
  height: 40px;
  border: 1px solid $tmf-gains;
  margin-bottom: -10px;
}

.usm-add-security-button-wrapper {
  position: absolute;
  top: 100px;
  right: 30px;
  & label {
    display: block;
    margin-top: 8px;
  }
}

.progress {
  width: 80px;
  display: inline-block;
  position: relative;
  top: 10px;
}

#reset-btn {
  margin-top: 30px;
}
</style>
